import * as yup from 'yup'

export const emailStepSchema = yup.object().shape({
  email: yup.string().email().required(),
})

export const twoFactorAuthenticationStepSchema = yup.object().shape({
  code: yup.string().required(),
})
